import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY } from 'rxjs';
import {
  CheckAccountPaotang,
  IApplications,
  ICasaAccountInquiry,
  InquiryAccountPaotang,
} from '../../interfaces';
import { HttpService } from '@web-di-ld/apps/http';
import { BehaviorSubject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PaymentDetailsService {
  private applications$ = new BehaviorSubject<any>({});
  selectedApplication$ = this.applications$.asObservable();

  constructor(private httpService: HttpService) {}

  async getCasaAccountInquiry() {
    return this.httpService
      .post(
        `/lfm-offers/app/v1/casa-account-inquiry`,
        {
          accept: 1,
        },
        false
      )
      .toPromise()
      .then((response: any) => {
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        return [];
      });
  }

  async inquiryAccountPaotang(): Promise<InquiryAccountPaotang> {
    return this.httpService
      .post<InquiryAccountPaotang>(
        `/lfm-offers/app/v1/inquiry-account-paotang`,
        {}
      )
      .toPromise()
      .then((response: any) => {
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        return EMPTY;
      });
  }

  async checkAccountPaotang(): Promise<CheckAccountPaotang> {
    return this.httpService
      .post<CheckAccountPaotang>(`/lfm-offers/app/v1/check-account-paotang`, {})
      .toPromise()
      .then((response: any) => {
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        throw error;
        // return EMPTY;
      });
  }
}
